import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  applyFilters: <PortalMessage id='t.app.orders.filters.applyFilters' defaultMessage='Apply Filters' />,
  filtersTitle: <PortalMessage id='t.app.pblManagement.research.pblManagementFilters' defaultMessage='Filters' />,
  title: <PortalMessage id='t.app.header.pblManagement.title' defaultMessage='Pay-by-link Management' />,
  filter: <PortalMessage id='t.app.orders.filters.filter' defaultMessage='Filter' />,
  export: <PortalMessage id='t.app.orders.filters.export' defaultMessage='Export' />,
  create: <PortalMessage id='t.app.pblManagement.create' defaultMessage='New Pay-by-link' />,
  noResultsMainText: (
    <PortalMessage id='t.app.generic.noResults.mainText' defaultMessage='No results found' />
  ),
  noResultsSecondaryText: (
    <PortalMessage id='t.app.generic.noResults.secondaryText' defaultMessage='Please try again with different filter criteria' />
  ),
  done: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.success' defaultMessage='Done!' />,
  successMessage: (
    <PortalMessage
      id='t.app.orders.operation.popup.successMessage'
      defaultMessage='The operation was successfully completed.'
    />
  ),
  exportResultFailedTitle: (
    <PortalMessage
      id='t.app.credentials.recovery.password.error.message'
      defaultMessage='Oops! Something went wrong!'
    />
  ),
  exportResultDescriptionEmpty: (
    <PortalMessage
      id='t.app.orders.export.response.error.empty'
      defaultMessage='The search produced no data for export. Please change search criteria and try again.'
    />
  ),
  exportResultDescriptionExcede: (
    <PortalMessage
      id='t.app.orders.export.response.error.excede'
      defaultMessage='The search results exceed the export limit. Please refine your criteria and try again.'
    />
  ),
  close: <PortalMessage id='t.app.project.btn.close' defaultMessage='Close' /> // It is used on the Saga. Do not delete
}

export const messages = defineMessages({
  resetFilters: {
    id: 't.app.orders.filters.resetFilters',
    defaultMessage: 'Reset criteria'
  },
  pageTitle: {
    id: 't.app.pblManagement.page.title',
    defaultMessage: 'XPay | Pay-by-link Management'
  }
})

export default formattedMessage
